import { FC } from 'react';
import { quotes } from './constants';
import classNames from 'classnames';
import { QuoteCard } from 'components/Cards/QuoteCard';

interface Props {
  backup?: boolean;
}

export const Community: FC<Props> = ({ backup }) => {
  return (
    <div className={classNames('community-container', { backup })}>
      <div className="community-texts">
        <span className="h2-dtm">
          Oath donors have already given more than 1,000,000+ unique donations
        </span>
        <span className="h4-text">Find out why our donors are choosing Oath.</span>
      </div>
      <div className="list-experiences">
        {quotes.map((quote, i) => (
          <QuoteCard
            key={i}
            title={quote.title}
            description={quote.description}
            author={quote.author}
            location={quote.location}
            photo={quote.photo}
            backup={backup}
          />
        ))}
      </div>
    </div>
  );
};
